import { Precision } from '@components/date-picker/src/DatePickerUtils';
import { useConfig } from '@components/config-provider/src';
import { useMemoizedFn } from '@tinper/hooks'
import { convertArrayStringToArray } from '@utils/arrayStringToArray';


export function useRenderLabel() {
  const { locale } = useConfig();
  return useMemoizedFn((type: Precision, data: number) => {

    if (['zh-CN', 'zh-TW'].includes(locale.locale)) {
      const label =
        locale.DateTimePicker[type as keyof typeof locale.DateTimePicker] ?? '';
      return `${data}${label}`;
    }

    // @ts-ignore
    const monthLocale = locale.Calendar.months ? convertArrayStringToArray(locale.Calendar.months) : locale.Calendar.months

    const labelMap = {
      [type]: data,
      week: `W${data}`,
      quarter: `Q${data}`,
      month: monthLocale[data - 1],
    }

    return labelMap[type] ?? data;
  });

}
